<template>
  <div class="preview-wrapper" v-show="show">
    <div class="wrapper" @click="show=false">
    </div>
    <div class="img-wrapper">
      <!-- <div style="font-size:14px;margin-top:10px;color:#ed4014;">如需打印请按ctrl+P</div> -->
      <img :src="imageSrc">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      imageSrc: ''
    }
  },
  methods: {
    showImage(src) {
      if (!src) return;
      this.imageSrc = src
      this.show = true
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.imageSrc = ''
      }
    }
  }
}
</script>


<style lang="less" scoped>
.preview-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  .img-wrapper {
    position: absolute;
    width: 80%;
    height: 80%;
    margin: 50px 10%;
    background: #fff;
    text-align: center;
    overflow-y: auto;
    img {
      max-width: 80%;
      padding-top: 50px;
    }
  }
  .wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
